export default __webpack_public_path__ + "locales/pt/JavascriptSdk.json?hash=5cf106319d3f639160e7a6434665c0e8";